const FinishedOrders = () => {
  // lista zavrsenih narudzbi sa samo cenom i proizvodima 
  return <></>;
};
export default FinishedOrders;
